export const incompletePushScoreValues = [undefined, null, "", -1];
